import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IReportingModel } from "@/Report/Models/UI/IReportingModel";
import { EmbeddedReport } from "./EmbeddedReport";

class ReportingTabState {
    public Model: IReportingModel;
}

class ReportingTab extends React.Component<EmptyProps, ReportingTabState> {
    private listenerId: string;

    constructor(props: EmptyProps) {
        super(props);

        const initialState = new ReportingTabState();
        initialState.Model = reportingStore.ReportingModel;
        this.state = initialState;
    }

    public render(): JSX.Element {
        var reportingConfigured = false;
        if (this.state.Model && !(this.state.Model.get("MainReportingURL") == null) && this.state.Model.get("MainReportingURL").length > 0) {
            reportingConfigured = true;
        }

        return (
            <div className="workspace">
                <div id="posref" className="ws-scrollable">
                    <div className="myle-doc-tb main-content myle-form documents">
                        {reportingConfigured && <EmbeddedReport Model={this.state.Model} />}
                        {!reportingConfigured && <span> Reporting not configured.</span>}
                    </div>
                </div>
                <div className="ws-footer" />
            </div>
        );
    }

    public componentDidMount(): void {
        this.listenerId = reportingStore.AddChangeListener(this.changeListener, this, "reporting-store-listener");

        window.setTimeout(
            () => {
                var operation = new LocalEvent(LocalOperations.Reporting.Store_Mounted);
                LocalEventDispatcher.dispatch(operation);
            },
            50
        );
    }

    private changeListener(): void {
        var state = new ReportingTabState();
        state.Model = reportingStore.ReportingModel;
        this.setState(state);
    }

    public shouldComponentUpdate(nextProps: EmptyProps, nextState: ReportingTabState): boolean {
        return (
            this.state.Model !== nextState.Model
        );
    }

    public componentWillUnmount(): void {
        reportingStore.RemoveChangeListener(this.listenerId);
    }
}

export { ReportingTab };
